/// <reference types="@types/google.maps" />
import { AfterViewInit, Component, EventEmitter, NgZone, Output } from '@angular/core';
import { LogLevel, LoggerAbstractService } from 'bqx-logging';
import { NGXLogger } from 'ngx-logger';
import { AbstractGoogleMapApiService } from 'src/app/services/google-maps/abstract-google-maps.service';
import { InputFocusAbstractService } from 'src/app/services/input-focus/input-focus.abstract.service';
import { TextInputComponent } from '../text-input/text-input.component';
@Component({
  selector: 'app-google-address-input',
  templateUrl: './google-address-input.component.html',
  styleUrls: ['./google-address-input.component.css']
})
export class GoogleAddressInputComponent extends TextInputComponent implements AfterViewInit {
  // @Input() type: string;
  autocomplete: google.maps.places.Autocomplete;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onGooglePlaceUpdate: EventEmitter<google.maps.places.PlaceResult> = new EventEmitter<google.maps.places.PlaceResult>(null);

  constructor(
    private ngZone: NgZone,
    private googleMapsApiService: AbstractGoogleMapApiService,
    private focusInputService: InputFocusAbstractService,
    loggerService: LoggerAbstractService,
    logger: NGXLogger

  ) {
    super(focusInputService, loggerService, logger);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    //Fixed: Added check to avoid input.nativeElement undefined error
    if (!this.readOnly) this.initializeGoogleAutoComplete();
  }

  private initializeGoogleAutoComplete(): void {
    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    try {
      this.googleMapsApiService.loadGoogleMapsApi().then(() => {
        const options = {
          types: ['address'],
          componentRestrictions: { country: 'us' }
        };

        this.autocomplete = new google.maps.places.Autocomplete(this.input.nativeElement, options);
        this.autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            const place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
            this.onGooglePlaceUpdate.emit(place);
          });
        });
      });
    } catch (error) {
      this.loggerService.postLogData(LogLevel.Error, 'Google-Address-input API service failure', error, '')
    }
  }
}
